import { MspAsnEffects } from './asn/effects';
import { MspEventRulesEffects } from './event-rules/effects';
import { MspGeoEffects } from './geo/effects';
import { CwmConfigEffects } from './integrations/cwm/config/effects';
import { CwmCredsEffects } from './integrations/cwm/credentials/effects';
import { HaloCredsEffects } from './integrations/halo/credentials/effects';
import { HaloConfigEffects } from './integrations/halo/config/effects';
import { MspIpEffects } from './ip/effects';
import { MspAccessGroupsEffects } from './msp-access-groups/msp-access-groups.effects';
import { MspGraphUserEffects } from './msp-graph-user/effects';
import { MspUserEffects } from './msp-user/effects';
import { MspEffects } from './msp/effects';
import { DattoConfigEffects } from './integrations/datto/config/effects';
import { DattoCredsEffects } from './integrations/datto/credentials/effects';
import { CwmMappingsEffects } from './integrations/cwm/mappings/effects';
import { HaloMappingsEffects } from './integrations/halo/mappings/effects';
import { DattoMappingsEffects } from './integrations/datto/mappings/effects';

export const MspModuleEffects = [
    MspAsnEffects,
    MspEventRulesEffects,
    MspGeoEffects,
    MspIpEffects,
    MspAccessGroupsEffects,
    MspGraphUserEffects,
    MspUserEffects,
    MspEffects,
    CwmConfigEffects,
    DattoMappingsEffects,
    HaloMappingsEffects,
    CwmMappingsEffects,
    CwmCredsEffects,
    HaloConfigEffects,
    HaloCredsEffects,
    DattoConfigEffects,
    DattoCredsEffects,
];
